import type { SVGProps } from 'react';
const SvgSettingsInputHdmi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#settings_input_hdmi_svg__a)">
      <path
        fill="currentColor"
        d="M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1ZM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4Z"
      />
    </g>
    <defs>
      <clipPath id="settings_input_hdmi_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSettingsInputHdmi;
